import React, { useState } from 'react';

import { Collapse, IconButton } from '@material-ui/core';

import Alert from '@material-ui/lab/Alert';
import CloseIcon from '@material-ui/icons/Close';

const CollapseAlert = (props) => {
  const message = 'test';

  const [show, setShow] = useState(false);

  const handleClick = (evt) => setShow(false);

  return (
    <>
      <Collapse in={show}>
        <Alert
          variant="filled"
          severity="warning"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClick}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {message}
        </Alert>
      </Collapse>

      {React.cloneElement(props.children, { message: message, status: show })}
    </>
  );
};

export default CollapseAlert;
